import { Building2 } from 'lucide-react';
import { useConference } from '@/context/ConferenceContext';

const Logo = () => {
  const { getConferenceShortName, importantDetails, loading } = useConference();

  if (loading) {
    return (
      <div className="flex items-center gap-2">
        <div className="w-10 h-10 bg-gray-200 rounded-xl animate-pulse"></div>
        <div>
          <div className="w-20 h-5 bg-gray-200 rounded animate-pulse"></div>
          <div className="w-24 h-3 bg-gray-200 rounded animate-pulse mt-1"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <div className="w-10 h-10 bg-sky-500 rounded-xl flex items-center justify-center">
        <Building2 className="text-white" size={24} />
      </div>
      <div>
        <div className="text-xl font-bold text-gray-900">{getConferenceShortName()}</div>
        <div className="text-xs text-gray-500">{importantDetails?.ConferenceDates || 'September 17-19, 2026'}</div>
      </div>
    </div>
  );
};

export default Logo;
